/*
 Y     （Y=X）                           0≤X≤1万
 Y.Y万+（保留小数点后一位）          1万≤X＜10万
 Y万+ （直接抹掉后4位）          10万≤X≤1亿
 Y.Y亿+（保留小数点后一位）          1亿≤X＜10亿
 Y亿+ （直接抹掉后8位）          X≥10亿
 * */
var Number = function (number) {
    var n = parseInt(number)||0;
    this.number = n;
}
Number.prototype = {
    format: function () {
        if (this.number <= 0) {
            return "0";
        }
        else if (this.number < 10000) {
            return this.number.toString();
        }
        else if (this.number < 100000) {
            return (this.number / 10000).toFixed(1).replace(/\.?0*$/ig, '') + "万";
        }
        else if (this.number <= 100000000) {
            return (this.number / 10000).toFixed(0) + "万";
        } else if (this.number < 100000000 * 10) {//10亿
            return (this.number / 100000000).toFixed(1).replace(/\.?0*$/ig, '')+ "亿";
        }
        else
            return (this.number / 100000000).toFixed(0)+ "亿";
    }
}

export default Number;